import { ru } from '@/i18n/ru';

/** The browser tab's title: the product, then the organization when it has its own name. */
export function tabTitle(product: string, org: string): string {
  return org && org !== product ? `${product}${ru.app.titleSeparator}${org}` : product;
}
